<template>
  <div class="empty-content" v-if="false">
    <img :src="iconEmptyHolder" alt=""/>
    <div class="title">{{title}}</div>
    <div class="description">{{description}}</div>
  </div>
</template>

<script>
import IconEmptyHolder from '../assets/icon-empty-holder.svg'

export default {
  data() {
    return {
      title: '検索結果なし',
      description: '検索ワードを変えてもう一度検索してみてください。',
      iconEmptyHolder: IconEmptyHolder
    }
  }
}
</script>

<style scoped>
.empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: calc(50vh - 80px);
}

.empty-content .title {
  padding-top: 16px;
  font-size: 16px;
  font-weight: bold;
}

.empty-content .description {
  padding: 8px 16px;
  font-size: 12px;
  color: #9b9ca7;
}

</style>